module.exports = __webpack_public_path__ + "static/images/97277870.png";